(function () {
    'use strict';

    angular.module("imApp").factory("oeeStateEquipmentService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 244,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 245,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
